<template>
  <div>
    <div class="panel mt-20" v-if="showFilter">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="80px"
        >
          <el-form-item
            label="客户名"
            prop="name"
            v-if="isMobile() && !filterShow"
          >
            <el-input
              size="small"
              v-model="filter.name"
              autocomplete="off"
              @keyup.enter.native="reqeustCustomers()"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item
              label="客户名"
              prop="name"
              v-if="filterShow || !isMobile()"
            >
              <el-input
                size="small"
                v-model="filter.name"
                autocomplete="off"
                @keyup.enter.native="reqeustCustomers()"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="SAP Code"
              prop="sap_code"
              v-if="(filterShow || !isMobile()) && isPlatformUser && !repeat"
            >
              <el-input
                size="small"
                v-model="filter.sap_code"
                autocomplete="off"
                @keyup.enter.native="reqeustCustomers()"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="中间商" prop="dealer_id" v-if="showDealer">
              <dealer-select :val="filter.dealer_id" @change="filter.dealer_id = $event"
                ref="filterDealer"></dealer-select>
            </el-form-item> -->
            <template v-if="isPlatformUser">
              <el-form-item
                label="销售(服务)"
                prop="platform_user_id"
                v-if="auth.belongsToDepartment(1)"
              >
                <sale-select
                  :val="filter.platform_user_id"
                  @change="filter.platform_user_id = $event"
                  ref="filterUser"
                ></sale-select>
              </el-form-item>
              <el-form-item
                label="销售(工业)"
                prop="industry_sale_id"
                v-if="auth.belongsToDepartment(2)"
              >
                <sale-select
                  :val="filter.industry_sale_id"
                  @change="filter.industry_sale_id = $event"
                  ref="filterUser"
                ></sale-select>
              </el-form-item>
              <el-form-item
                label="销售(科学)"
                prop="science_sale_id"
                v-if="auth.belongsToDepartment(3)"
              >
                <sale-select
                  :val="filter.science_sale_id"
                  @change="filter.science_sale_id = $event"
                  ref="filterUser"
                ></sale-select>
              </el-form-item>
            </template>
            <!-- <el-form-item label="销售" prop="user_id" v-else>
              <sale-select
                :val="filter.user_id"
                :role="FunctionalRoles.Sale"
                @change="filter.user_id = $event"
                ref="filterUser"
              ></sale-select>
            </el-form-item> -->
            <el-form-item
              label="电话销售"
              prop="telesale_id"
              v-if="isPlatformUser"
            >
              <telesale-select
                :val="filter.telesale_id"
                @change="filter.telesale_id = $event"
                ref="filterTelesale"
              ></telesale-select>
            </el-form-item>
            <el-form-item label="区域" prop="area_id" v-if="isPlatformUser">
              <area-select
                :showNoAreaSelect="true"
                :val="filter.area_id"
                :clearable="true"
                @change="filter.area_id = $event"
                ref="filterAreaID"
              ></area-select>
            </el-form-item>
            <el-form-item label="省市区" prop="area">
              <el-cascader
                style="width: 100%"
                size="small"
                class="long"
                :options="regionDataPlus"
                v-model="filter.area"
                ref="filterArea"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="拥有设备" prop="item_category_id">
              <item-category-select
                :val="filter.item_category_id"
                :category="2"
                @change="filter.item_category_id = $event"
                ref="filterItemCategoryID"
              ></item-category-select>
            </el-form-item>
            <el-form-item
              label="授权服务商"
              prop="is_fix_dealer"
              v-if="isPlatformUser"
            >
              <el-select size="small" v-model="filter.is_fix_dealer">
                <el-option :key="0" label="不限" :value="0"></el-option>
                <el-option :key="1" label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户状态" v-if="!deleted">
              <el-select
                v-model="filter.status"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                :clearable="true"
              >
                <el-option
                  v-for="(value, index) in CustomerStatusMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="客户类型" v-if="isPlatformUser">
              <el-select
                v-model="filter.category"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                :clearable="true"
              >
                <el-option
                  v-for="(value, index) in CustomerCategroyMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <template v-if="isPlatformUser">
              <el-form-item
                label="级别(服务)"
                v-if="auth.belongsToDepartment(1)"
              >
                <CustomerRankSelect
                  v-model="filter.rank"
                  :filter="true"
                ></CustomerRankSelect>
              </el-form-item>
              <el-form-item
                label="级别(工业)"
                v-if="auth.belongsToDepartment(2)"
              >
                <CustomerRankSelect
                  v-model="filter.rank_industry"
                  :filter="true"
                ></CustomerRankSelect>
              </el-form-item>
              <el-form-item
                label="级别(科学)"
                v-if="auth.belongsToDepartment(3)"
              >
                <CustomerRankSelect
                  v-model="filter.rank_science"
                  :filter="true"
                ></CustomerRankSelect>
              </el-form-item>
            </template>
            <el-form-item label="直销/间销" v-if="isPlatformUser">
              <el-select
                v-model="filter.special_mark"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option :key="-1" label="不限" :value="-1"></el-option>
                <el-option :key="1" label="直销客户" :value="1"></el-option>
                <el-option :key="2" label="间销客户" :value="2"></el-option>
                <el-option :key="0" label="其他" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="重点客户" v-if="isPlatformUser">
              <el-select
                v-model="filter.important"
                size="small"
                placeholder="请选择"
              >
                <el-option :value="0" key="0" label="不限"></el-option>
                <el-option :value="2" key="2" label="是"></el-option>
                <el-option :value="1" key="1" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="认证状态" v-if="isPlatformUser">
              <el-select
                v-model="filter.certification"
                size="small"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option :key="0" label="不限" :value="0"></el-option>
                <el-option
                  :key="2"
                  label="已认证（有 SAP Code）"
                  :value="2"
                ></el-option>
                <el-option
                  :key="1"
                  label="未认证（无 SAP Code）"
                  :value="1"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="C4C ID" v-if="isPlatformUser">
              <el-input
                size="small"
                v-model.number="filter.c4c_id"
                autocomplete="off"
                @keyup.enter.native="reqeustCustomers()"
              ></el-input>
            </el-form-item>
            <el-form-item label="中文名称" v-if="isPlatformUser">
              <el-checkbox v-model="filter.not_correct_name"
                >中文名为英文</el-checkbox
              >
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                reqeustCustomers()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
            <el-button
              v-if="
                !noFilter &&
                !isMobile() &&
                !deleted &&
                !repeat &&
                auth.isPlatformUser()
              "
              v-permission="Auth.customerBatchAction"
              type="text"
              size="mini"
              class="text-primary"
              @click="batchPanelVisible = !batchPanelVisible"
            >
              批量操作此筛选结果
              <i class="el-icon-bottom el-icon--right"></i>
            </el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
        <div
          class="warn-panel mt-20 text-info-12"
          v-permission="Auth.customerBatchAction"
          v-if="batchPanelVisible"
        >
          <div>当前筛选结果{{ total }}条数据，批量进行如下操作：</div>
          <div class="mt-10">
            <span>转移到新的销售</span>
            <sale-select
              class="ml-10"
              :val="batch.user_id"
              :role="FunctionalRoles.Sale"
              @change="batch.user_id = $event"
              ref="transferUserTarget"
            ></sale-select>
          </div>
          <div class="mt-10" v-if="isPlatformUser">
            <span>转移到新的电话销售</span>
            <telesale-select
              class="ml-10"
              :val="batch.telesale_id"
              @change="batch.telesale_id = $event"
              ref="transferTelesaleTarget"
            ></telesale-select>
          </div>
          <el-button
            class="mt-10"
            type="primary"
            size="small"
            @click="batchAction()"
            >确认操作</el-button
          >
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header" v-if="!deleted && !repeat">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startCustomerFomer()"
          v-permission="Auth.customerNew"
          >新客户</el-button
        >
        <file-button
          v-permission="Auth.customerIE"
          style="float: right"
          obj="customer"
          :importButton="false"
          :filter="filter"
          class="mobile-hide"
          @importCallback="importCallback"
        ></file-button>
      </div>
      <el-table
        v-if="!isMobile()"
        :data="customers"
        v-loading="loading"
        :row-style="{ color: deleted ? '#999' : '' }"
        class="mt-10"
        size="mini"
      >
        <el-table-column prop="name" label="客户信息 / 地址" min-width="200">
          <template slot-scope="scope">
            <customer-link
              :customer="scope.row"
              :repeat="repeat"
            ></customer-link>
            <el-tag
              class="ml-5"
              size="mini"
              type="success"
              v-if="scope.row.sap_code && !isPlatformUser"
              >官方认证</el-tag
            >
            <div v-if="scope.row.name_en" style="line-height: 1.4em">
              {{ scope.row.name_en }}
            </div>
            <div class="customer-tags" v-if="isPlatformUser">
              <el-tag size="mini" type="danger" v-if="scope.row.ccm == 1">
                NCR</el-tag
              >
              <!-- <el-tag size="mini" type="success" v-if="scope.row.certification == 2 && isPlatformUser">
                已认证</el-tag> -->
              <el-tag size="mini" type="info" v-if="scope.row.sap_code">{{
                scope.row.sap_code
              }}</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.c4c_id">{{
                scope.row.c4c_id
              }}</el-tag>
              <el-tag
                size="mini"
                type="warning"
                v-if="scope.row.special_mark == 1"
                >直销客户</el-tag
              >
              <el-tag
                size="mini"
                type="warning"
                v-else-if="scope.row.special_mark == 2"
                >间销客户</el-tag
              >
              <el-tag size="mini" type="danger" v-if="scope.row.important == 2"
                >重点客户</el-tag
              >
            </div>
            <div>
              {{ AreaTextMap[scope.row.area_id] }}
              {{ CodeToText[scope.row.province] }}{{ CodeToText[scope.row.city]
              }}{{ CodeToText[scope.row.county] }}
              {{ scope.row.address_detail }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="联系人" align="center" width="124">
          <template slot-scope="scope">
            <div>{{ scope.row.contact_name }}</div>
            <div>{{ scope.row.contact_phone_number }}</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="device_count" label="设备数量" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.device_count || 0 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="device_count" label="类别" align="center">
          <template slot-scope="scope">
            <span>{{ CustomerCategroyMap[scope.row.category] }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="级别" align="center" min-width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.rank > 0">
              {{ scope.row.service_stage.name }}(服务)
            </div>
            <!-- <div v-if="scope.row.rank_industry > 0">
              {{ scope.row.industry_stage.name }}(工业)
            </div>
            <div v-if="scope.row.rank_science > 0">
              {{ scope.row.science_stage.name }}(科学)
            </div> -->
          </template>
        </el-table-column>
        <!-- <el-table-column prop="dealer.name" label="中间商" align="left" v-if="showDealer">
          <template slot-scope="scope">
            {{ scope.row.dealer_id == 0 ? '' : scope.row.dealer.name }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="销售" align="center" v-if="!isPlatformUser">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="销售"
          align="center"
          v-if="isPlatformUser"
          min-width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.platform_user.name">
              {{ scope.row.platform_user.name }}(服务)
            </div>
            <div v-if="scope.row.industry_sale.name">
              {{ scope.row.industry_sale.name }}(工业)
            </div>
            <div v-if="scope.row.science_sale.name">
              {{ scope.row.science_sale.name }}(科学)
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="电话销售"
          align="center"
          width="120px"
          v-if="isPlatformUser"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.telesale.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deleted_reason"
          label="删除原因"
          align="center"
          v-if="deleted"
        >
        </el-table-column>
        <el-table-column
          prop="maintainance_amount"
          label="商机潜力值"
          width="110"
          align="center"
          v-if="
            hasAuth('customerMaintainanceList') && isPlatformUser && !deleted
          "
        >
          <template slot="header"
            >商机潜力值<CustomTip :t="5"></CustomTip
          ></template>
          <template slot-scope="scope"
            ><MaintainanceAmount
              :customerid="scope.row.id"
              :key="scope.row.id"
            ></MaintainanceAmount
          ></template>
        </el-table-column>
        <el-table-column label="客户状态" align="center" v-if="!deleted">
          <template slot-scope="scope">
            <status-tag
              class="font-12"
              :type="scope.row.status == 1 ? 'success' : 'danger'"
              :name="CustomerStatusMap[scope.row.status]"
            ></status-tag>
            <!-- <br />
            <status-tag
              class="font-12"
              :type="scope.row.system_status == 1 ? 'success' : 'danger'"
              :name="`${
                scope.row.system_status == 1 ? '启用' : '禁用'
              }（系统状态）`"
            ></status-tag> -->
          </template>
        </el-table-column>

        <el-table-column
          align="right"
          label="操作"
          width="100"
          class-name="mobile-hide"
        >
          <template slot-scope="scope">
            <router-link
              class="text-primary"
              v-permission="Auth.customerRepeatShow"
              v-if="repeat"
              :to="'/dashboard/customers/repeat/' + scope.row.id"
              :title="scope.row.name"
            >
              <el-button type="primary" plain size="mini"> 查看详情 </el-button>
            </router-link>
            <router-link
              class="text-primary"
              v-permission="Auth.customerShow"
              v-else-if="deleted"
              :to="'/dashboard/customers/deleted/' + scope.row.id"
              :title="scope.row.name"
            >
              <el-button type="primary" plain size="mini"> 查看详情 </el-button>
            </router-link>
            <customer-link
              v-else
              class="text-primary"
              style="font-size: 12px"
              v-permission="Auth.customerShow"
              :customer="scope.row"
            >
              <el-button slot="content" size="mini" type="primary" plain
                >查看详情</el-button
              >
            </customer-link>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="item in customers" :key="item.id" class="flex-row-between">
          <div>
            <customer-link :customer="item"></customer-link>
            <el-tag
              class="ml-5"
              size="mini"
              type="success"
              v-if="item.sap_code && !isPlatformUser"
              >官方认证</el-tag
            >
            <div v-if="item.name_en" style="line-height: 1.4em">
              {{ item.name_en }}
            </div>
            <div class="customer-tags" v-if="isPlatformUser">
              <el-tag size="mini" type="danger" v-if="item.ccm == 1">
                NCR</el-tag
              >
              <el-tag size="mini" type="info" v-if="item.sap_code">{{
                item.sap_code
              }}</el-tag>
              <el-tag size="mini" type="warning" v-if="item.special_mark == 1"
                >直销客户</el-tag
              >
              <el-tag
                size="mini"
                type="warning"
                v-else-if="item.special_mark == 2"
                >间销客户</el-tag
              >
              <el-tag size="mini" type="danger" v-if="item.important == 2"
                >重点客户</el-tag
              >
            </div>
            <div class="text-secondary font-12" v-if="item.industry">
              <!-- <span>{{ item.dealer_id == 0 ? '平台' : item.dealer.name }}</span> -->
              <span v-if="item.industry.length > 0">{{ item.industry }}</span>
            </div>
            <div class="text-info-12">
              {{ CodeToText[item.province] }}{{ CodeToText[item.city]
              }}{{ CodeToText[item.county] }}
              {{ item.address_detail }}
            </div>
          </div>
          <!-- <div style="width: 80px; text-align: right; font-size: 12px">
            <span>{{ item.user.name }}</span>
          </div> -->
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <customer-former
      :model="customerForm"
      :category="category"
      :show.sync="addCustomerFormVisible"
      @createdCustomer="createdCustomer"
    ></customer-former>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import {
  createCustomer,
  customerList,
  customerBatchTransfer,
} from '../../service/getData'
import { regionDataPlus } from '@/util/area_tool'
import CustomerFormer from '@/components/customer'
import DealerSelect from '@/components/select/dealer_select'
import SaleSelect from '@/components/select/sale_select'
import TelesaleSelect from '@/components/select/telesale_select'

import ItemCategorySelect from '@/components/select/item_category_select'
import AreaSelect from '@/components/select/area_select'
import auth from '@/util/auth'
import { CodeToText } from '@/util/area_tool'
import { isMobile, scrollToTop } from '@/util/index'
import store from '@/store/store'
import { hasAuth } from '@/permission'

import {
  AreaTextMap,
  CustomerStatusMap,
  CustomerCategroyMap,
  FunctionalRoles,
} from '@/config/global'

export default {
  props: {
    dealerID: {
      type: Number,
      default: 0,
    },
    category: {
      type: Number,
      default: 0,
    },
    deleted: {
      type: Boolean,
      default: false,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomerFormer,
    DealerSelect,
    SaleSelect,
    ItemCategorySelect,
    AreaSelect,
    TelesaleSelect,
  },
  data() {
    return {
      hasAuth,
      regionDataPlus,
      FunctionalRoles,
      scrollToTop,
      filter: {
        is_fix_dealer: 0,
        rank: '',
        rank_industry: '',
        rank_science: '',
        name: '',
        sap_code: '',
        dealer_id: '',
        area_id: '',
        user_id: '',
        telesale_id: '',
        platform_user_id: '',
        industry_sale_id: '',
        science_sale_id: '',
        item_category_id: '',
        category: this.category,
        special_mark: -1,
        important: 0,
        c4c_id: '',
        not_correct_name: false,
        area: [],
        size: 20,
        status: '',
        page: 1,
      },
      userInfo: store.getters.userInfo,
      batch: {
        user_id: '',
        telesale_id: '',
      },
      batchPanelVisible: false,
      isMobile,
      CodeToText,
      AreaTextMap,
      CustomerStatusMap,
      CustomerCategroyMap,
      total: 0,
      customers: [],
      auth,
      customerForm: {},
      filterShow: false,
      addCustomerFormVisible: false,
      loading: false,
    }
  },
  computed: {
    noFilter() {
      return (
        this.filter.name.length == 0 &&
        !this.filter.dealer_id &&
        !this.filter.area_id &&
        !this.filter.user_id &&
        !this.filter.item_category_id &&
        !this.filter.telesale_id &&
        !this.filter.status &&
        this.filter.special_mark == -1 &&
        (!this.filter.area || this.filter.area.length == 0)
      )
    },
    isPlatformUser() {
      return auth.isPlatformUser()
    },
    showFilter() {
      // if (this.dealerID > 0 && this.customers.length <= 10) {
      //   return false
      // }
      return true
    },
    showDealer() {
      return !(this.dealerID > 0 || this.userInfo.dealer_id > 0)
    },
  },
  watch: {
    // $route(to, from) {
    //   this.filter.dealer_id = ''
    //   this.reqeustCustomers()
    // },
    'filter.page': function () {
      this.reqeustCustomers()
    },
  },
  created() {
    if (this.dealerID) {
      this.filter.dealer_id = this.dealerID
    }
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    // let area_id = parseInt(this.$route.query.area_id || 0)
    // if (area_id == 0) {
    //   area_id = null
    // }
    // this.filter = {
    //   page: parseInt(this.$route.query.page || 1),
    //   size: parseInt(this.$route.query.size || 20),
    //   dealer_id: parseInt(this.$route.query.dealer_id || 0),
    //   item_category_id: parseInt(this.$route.query.item_category_id || 0),
    //   name: this.$route.query.name || '',
    //   sap_code: this.$route.query.sap_code || '',
    //   status: parseInt(this.$route.query.status || 0) || '',
    //   category: parseInt(this.$route.query.category || 0) || '',
    //   area_id: area_id,
    //   user_id: parseInt(this.$route.query.user_id || 0),
    //   telesale_id: parseInt(this.$route.query.telesale_id || 0),
    //   area: this.$route.query.area || [],
    //   special_mark: parseInt(this.$route.query.special_mark || -1),
    //   certification: parseInt(this.$route.query.certification || 0),
    // }

    // if (this.dealerID > 0) {
    //   this.filter.dealer_id = this.dealerID
    // }
    this.reqeustCustomers()
  },
  methods: {
    requestParams() {
      // 所属环境不同，强制设置dealer_id
      // let dealerID = this.filter.dealer_id
      // if (this.dealerID > 0) {
      //   dealerID = this.dealerID
      // }
      // if (this.userInfo.dealer_id > 0) {
      //   dealerID = this.userInfo.dealer_id
      // }
      // let data = {
      //   size: this.filter.size,
      //   page: this.filter.page - 1,
      //   name: this.filter.name,
      //   sap_code: this.filter.sap_code,
      //   special_mark: this.filter.special_mark,
      //   certification: this.filter.certification,
      //   dealer_id: dealerID || 0,
      //   area_id: this.filter.area_id || 0,
      //   status: this.filter.status || 0,
      //   category: this.filter.category || 0,
      //   item_category_id: this.filter.item_category_id || 0,
      // }

      // if (this.isPlatformUser) {
      //   data.platform_user_id = this.filter.user_id || 0
      //   data.telesale_id = this.filter.telesale_id || 0
      // } else {
      //   data.user_id = this.filter.user_id || 0
      // }
      let data = this.clone(this.filter)
      let area = this.filter.area
      if (area.length > 0) {
        data.province = area[0]
      }
      if (area.length > 1) {
        data.city = area[1]
      }
      if (area.length > 2) {
        data.county = area[2]
      }
      data.page -= 1
      return data
    },
    async reqeustCustomers(callback) {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      this.loading = true
      let data = this.requestParams()
      data.is_deleted = this.deleted ? 1 : 0
      data.is_repeat = this.repeat
      let res = await customerList(data)
      if (res.code == 0) {
        this.customers = res.data.list
        this.total = res.data.total
      }
      if (callback) {
        callback()
      }
      this.loading = false
    },
    async requestDevices(query) {
      if (query !== '') {
        this.deviceLoading = true
        let data = {
          query: query,
          page: 0,
          size: 10,
          category: 2,
        }
        let res = await itemCategoryList(data)
        this.deviceLoading = false
        this.devices = res.data.list
      } else {
        this.devices = []
      }
    },
    startCustomerFomer() {
      // this.customerForm = {
      //   name: '',
      //   dealer_id: Math.max(this.dealerID, this.userInfo.dealer_id),
      //   dealer_category_id: 1,
      //   area_id: 0,
      //   industry: '',
      //   source: '',
      //   scale: '',
      //   remark: '',
      //   status: 1,
      //   category: 1,
      //   platform_user_id: null,
      //   telesale_id: null,
      //   area: [],
      //   address_detail: '',
      //   sap_code: '',
      //   special_mark: -1,
      //   important: 1,
      //   special_mark: 0,
      //   agent_name: null,
      //   agent_mobile: null,
      // }
      this.addCustomerFormVisible = true
    },
    async batchAction() {
      var that = this
      this.reqeustCustomers(function () {
        if (that.total == 0) {
          that.$message.error('没有客户需要转移')
          return
        }
        if (!that.batch.user_id && !that.batch.telesale_id) {
          that.$message.error('请选择转移目标')
          return
        }
        let data = that.requestParams()
        data.target_user_id = that.batch.user_id
        data.target_telesale_id = that.batch.telesale_id
        let html = ''
        if (data.name.length > 0) {
          html += '<div>客户名：' + data.name + '</div>'
        }
        if (data.sap_code.length > 0) {
          html += '<div>SAP Code：' + data.sap_code + '</div>'
        }
        // if (that.$refs.filterDealer && data.dealer_id > 0) {
        //   let lists = that.$refs.filterDealer.lists || []
        //   let dealers = lists.filter((item) => {
        //     return item.id == data.dealer_id
        //   })
        //   if (dealers.length > 0) {
        //     html += '<div>中间商：' + dealers[0].name + '</div>'
        //   }
        // }
        if (that.$refs.filterUser && data.user_id > 0) {
          let lists = that.$refs.filterUser.lists || []
          let users = lists.filter((item) => {
            return item.id == data.user_id
          })
          if (users.length > 0) {
            html += '<div>销售：' + users[0].name + '</div>'
          }
        }
        if (that.$refs.filterTelesale && data.telesale_id > 0) {
          let lists = that.$refs.filterTelesale.lists || []
          let users = lists.filter((item) => {
            return item.id == data.telesale_id
          })
          if (users.length > 0) {
            html += '<div>电话销售：' + users[0].name + '</div>'
          }
        }
        if (that.$refs.filterAreaID && data.area_id > 0) {
          html +=
            '<div>地区：' + that.$refs.filterAreaID.selectedLabel + '</div>'
        }
        if (data.province) {
          html += '<div>省：' + CodeToText[data.province] + '</div>'
        }

        if (data.province == '') {
          html += '<div>省市区：全部</div>'
        }
        if (data.city) {
          html += '<div>市：' + CodeToText[data.city] + '</div>'
        }
        if (data.county) {
          html += '<div>区：' + CodeToText[data.county] + '</div>'
        }
        if (
          that.$refs.filterItemCategoryID.lists &&
          data.item_category_id > 0
        ) {
          let lists = that.$refs.filterItemCategoryID.lists || []
          let ics = lists.filter((item) => {
            return item.id == data.item_category_id
          })
          if (ics.length > 0) {
            html += '<div>拥有设备：' + ics[0].name + '</div>'
          }
        }
        if (data.status > 0) {
          html += '<div>状态：' + CustomerStatusMap[data.status] + '</div>'
        }
        if (data.category > 0) {
          html +=
            '<div>客户类型：' + CustomerCategroyMap[data.category] + '</div>'
        }
        let targetUserName = ''
        if (that.$refs.transferUserTarget) {
          let lists = that.$refs.transferUserTarget.lists || []
          let users = lists.filter((item) => {
            return item.id == data.target_user_id
          })
          if (users.length > 0) {
            targetUserName = users[0].name
          }
        }

        let targetTelesaleName = ''
        if (that.$refs.transferTelesaleTarget) {
          let lists = that.$refs.transferTelesaleTarget.lists || []
          let users = lists.filter((item) => {
            return item.id == data.target_telesale_id
          })
          if (users.length > 0) {
            targetTelesaleName = users[0].name
          }
        }

        if (data.special_mark == 0) {
          html += '<div>直销客户：其他</div>'
        } else if (data.special_mark == 1) {
          html += '<div>直销客户：直销客户</div>'
        } else if (data.special_mark == 2) {
          html += '<div>直销客户：间销客户</div>'
        }

        for (const key in data) {
          const element = data[key]
          if (element == '') {
            data[key] = null
          }
        }

        let confirmText =
          '<div class="text-danger">是否确定将' +
          that.total +
          '条数据转移如下：</div>'
        if (targetUserName.length > 0) {
          confirmText += '<div>销售：' + targetUserName + '</div>'
        }
        if (targetTelesaleName.length > 0) {
          confirmText += '电话销售：' + targetTelesaleName + '</div>'
        }
        confirmText +=
          '<div style="font-size:12px;margin-top:10px;">确认筛选条件：' +
          (html.length > 0 ? html : '无') +
          '</div>'
        that
          .$confirm(confirmText, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            customerBatchTransfer(data).then((res) => {
              if (res.code == 0) {
                that.batch.telesale_id = null
                that.batch.user_id = null
                that.$message({ message: '操作成功', type: 'success' })
                that.reqeustCustomers()
              }
            })
          })
      })
    },
    createdCustomer(customer) {
      this.customers.unshift(customer)
    },
    reset() {
      this.filter = {
        is_fix_dealer: 0,
        rank: '',
        rank_industry: '',
        rank_science: '',
        name: '',
        sap_code: '',
        dealer_id: '',
        area_id: '',
        user_id: '',
        telesale_id: '',
        platform_user_id: '',
        industry_sale_id: '',
        science_sale_id: '',
        item_category_id: '',
        not_correct_name: false,
        c4c_id: '',
        category: this.category,
        area: [],
        size: 20,
        status: '',
        page: 1,
      }
      this.batchPanelVisible = false
      this.reqeustCustomers()
    },
    importCallback(res) {
      if (res.code == 0) {
        this.reset()
      }
    },
  },
}
</script>

<style scoped>
/deep/ .el-checkbox__label {
  font-size: 12px !important;
}

.confirm-content div {
  font-size: 12px;
  margin-top: 5px;
  color: #555;
}

.sap-code-tag {
  display: inline-block;
  padding: 0px 3px;
  border-radius: 3px;
  font-size: 12px;
  background-color: #eee;
}

.customer-tags .el-tag {
  margin-right: 5px;
}
</style>

<style >
.warning-row {
  background: rgb(255, 250, 241);
}
</style>